export const colorTokens = {
  // Brand
  'color-primary': '#0f3460',
  'color-primary-hover': '#0d2d56',
  'color-primary-active': '#0a234a',
  'color-primary-light': '#e8edf4',
  'color-secondary': '#533483',
  'color-secondary-hover': '#452b6e',
  'color-accent': '#e94560',
  'color-accent-hover': '#d63b54',

  // Neutrals
  'color-background': '#ffffff',
  'color-surface': '#f8f9fc',
  'color-surface-hover': '#f0f2f7',
  'color-surface-active': '#e4e8f0',
  'color-border': '#d1d9e6',
  'color-border-strong': '#9aa5b4',
  'color-border-light': '#e8ecf2',
  'color-text': '#1a1a2e',
  'color-text-secondary': '#666680',
  'color-text-tertiary': '#999',
  'color-text-inverse': '#ffffff',
  'color-text-disabled': '#b0b0b0',

  // Status
  'color-success': '#2ecc71',
  'color-success-bg': '#eafaf1',
  'color-success-border': '#a3e4bc',
  'color-warning': '#f39c12',
  'color-warning-bg': '#fef9e7',
  'color-warning-border': '#f9d984',
  'color-error': '#e74c3c',
  'color-error-bg': '#fdedec',
  'color-error-border': '#f1948a',
  'color-info': '#3498db',
  'color-info-bg': '#ebf5fb',
  'color-info-border': '#85c1e9',

  // Overlay
  'color-overlay': 'rgba(0, 0, 0, 0.5)',
  'color-focus-ring': 'rgba(15, 52, 96, 0.25)',
} as const;

export type ColorTokens = typeof colorTokens;
